<tp-page-scaffold [pageAvailability]="availability$ | async">
  <article>
    <section>
      @if (server$ | async; as server) {
        <div class="section-title-row">
          <a class="back-button" routerLink="../..">
            <i class="fa-light fa-arrow-left"></i>
          </a>
          @if (cluster$ | async; as cluster) {
            <h2>Server {{ server.id }} ({{ cluster.id }})</h2>
          }
        </div>
        <tp-properties-table title="Server Details">
          <tp-properties-table-row key="Server ID">{{ server.id }}</tp-properties-table-row>
          <tp-properties-table-row key="Address" class="tp-address">
            {{ server.address }}
            <button class="btn-copy" mat-icon-button aria-label="copy" (click)="copyServerAddress(); $event.stopPropagation();" matTooltip="Copy to clipboard">
              <i class="fa-light fa-copy"></i>
            </button>
          </tp-properties-table-row>
          <tp-properties-table-row key="Status">{{ server.status | serverStatus }}</tp-properties-table-row>
        </tp-properties-table>
      } @else {
        <tp-spinner/>
      }
    </section>

    <section class="logs-section">
      @if ((serverId$ | async) != null) {
        <div class="section-title-row">
          <tp-logs-control-bar title="Server logs" (downloadLogs)="openDownloadLogsDialog()" (isStreamingEnabled$)="isStreamingEnabled = $event"/>
        </div>
        <tp-server-logs-viewing-pane [isStreamingEnabled]="isStreamingEnabled" [serverId]="(serverId$ | async)!"/>
      }
    </section>
  </article>
</tp-page-scaffold>
